<template>
  <div class="stats-panel">
    <StatTile label="Items" :value="stats.items.toLocaleString()" :sub="`${stats.itemsRun} run`" />
    <StatTile
      label="Total sales"
      :value="`$${Math.round(stats.totalSales / 1000).toLocaleString()}k`"
      tone="success"
      :sub="`$${stats.totalSales.toLocaleString()}`"
    />
    <StatTile label="Sold on Offer" :value="stats.itemsSoldOnOffer.toLocaleString()" :sub="soldOnOfferShare" />
    <StatTile
      label="Items sold"
      :value="stats.itemsSold.toLocaleString()"
      tone="success"
      :sub="`${Math.round(stats.sellThrough * 100)}% sell-through`"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { StatTile } from '@hds/auto-auction-com-components-shared';

// How the sale is going, in four figures.
//
// It used to walk the run list and the per-item bidding store itself, deciding
// which runtime statuses count as sold and which as merely finished. That is
// domain knowledge — the runtime's status vocabulary — and it belongs with the
// application, which is where the tally moved. This renders the tally.
//
// `itemsSoldIf` was the field's name; "IF" is the industry's shorthand for a
// lot that went to post-block negotiation, and nobody outside a sale office
// reads it. It is `itemsSoldOnOffer`, which is what the tile already said.
defineOptions({ name: 'StatsPanel' });

const props = defineProps({
  // { items, itemsRun, itemsSold, itemsSoldOnOffer, totalSales, sellThrough }.
  // `sellThrough` is a fraction, not a percentage.
  stats: { type: Object, required: true },
});

// Share of sold lots that settled on offer rather than on the block. Before any
// lot has sold there is no share to state, so the tile says when it applies.
const soldOnOfferShare = computed(() => {
  if (!props.stats.itemsSold) return 'Post-block';
  return `${Math.round((props.stats.itemsSoldOnOffer / props.stats.itemsSold) * 100)}% of sold`;
});
</script>

<style scoped>
.stats-panel {
  flex: 0.5 0.5 0;
  min-width: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  gap: var(--p-stats-panel-gap);
}
</style>
